import { layoutOf } from '../../domain/layout';
import { dualAxle, singleAxle } from '../wheel-placements';
import { RIGID_HAUL_TRUCK } from './dimensions';

const rigidHaulTruckWheels = RIGID_HAUL_TRUCK.axles.flatMap((axle, index) => {
  const spec = {
    axle: index + 1,
    x: axle.x,
    radius: RIGID_HAUL_TRUCK.wheelRadius,
    width: RIGID_HAUL_TRUCK.tyreWidth,
    halfTrack: axle.halfTrack,
  };
  return axle.fitment === 'dual'
    ? dualAxle({ ...spec, spacing: RIGID_HAUL_TRUCK.dualSpacing })
    : singleAxle(spec);
});

const RIGID_HAUL_TRUCK_LAYOUT = layoutOf(['single', 'dual']);

export {
  RIGID_HAUL_TRUCK_LAYOUT,
  rigidHaulTruckWheels as RIGID_HAUL_TRUCK_WHEELS,
};
